import { createContext } from "react";
import { Org, UserOrgRole } from "../../generated/core-api";

export interface OrgState {
  orgs: Org[];
  orgRoles: UserOrgRole[];
  ownRoleInOrg: (orgId: string) => UserOrgRole | undefined;
}

export const OrgContext = createContext<OrgState | undefined>(undefined);
